import React, { useState } from 'react';
import { Home, Building, Users, ArrowRight } from 'lucide-react';
export const Services = () => {
  const [activeTab, setActiveTab] = useState('seekers');
  return <section id="services" className="py-24 relative overflow-hidden" data-id="element-303">
      <div className="absolute -top-40 left-20 w-[400px] h-[400px] gradient-circle opacity-20" data-id="element-304"></div>
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] gradient-circle opacity-20" data-id="element-305"></div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-306">
        <div className="max-w-3xl mx-auto text-center mb-16 reveal" data-id="element-307">
          <div className="inline-block bg-glass px-4 py-1 rounded-full text-xs font-medium mb-6 text-[#00d4ff]" data-id="element-308">
            OUR SERVICES
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-309">
            Our <span className="text-gradient" data-id="element-310">Premium</span> Services
          </h2>
          <p className="text-lg text-gray-300" data-id="element-311">
            Tailored solutions for every stakeholder in the real estate
            ecosystem.
          </p>
        </div>
        {/* Tabs */}
        <div className="flex flex-col sm:flex-row justify-center mb-12 border-b border-[rgba(255,255,255,0.1)] reveal" data-id="element-312">
          <button className={`py-4 px-6 font-medium text-lg transition-all duration-300 ${activeTab === 'seekers' ? 'text-[#00d4ff] border-b-2 border-[#00d4ff] glow-text' : 'text-gray-400 hover:text-white'}`} onClick={() => setActiveTab('seekers')} data-id="element-313">
            For Property Seekers
          </button>
          <button className={`py-4 px-6 font-medium text-lg transition-all duration-300 ${activeTab === 'developers' ? 'text-[#00d4ff] border-b-2 border-[#00d4ff] glow-text' : 'text-gray-400 hover:text-white'}`} onClick={() => setActiveTab('developers')} data-id="element-314">
            For Developers & Firms
          </button>
          <button className={`py-4 px-6 font-medium text-lg transition-all duration-300 ${activeTab === 'additional' ? 'text-[#00d4ff] border-b-2 border-[#00d4ff] glow-text' : 'text-gray-400 hover:text-white'}`} onClick={() => setActiveTab('additional')} data-id="element-315">
            Additional Services
          </button>
        </div>
        {/* Tab Content */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-316">
          {activeTab === 'seekers' && <>
              <div className="bg-glass rounded-xl p-8 card-hover neon-border reveal" data-id="element-317">
                <div className="w-12 h-12 bg-[rgba(0,212,255,0.2)] rounded-lg flex items-center justify-center mb-6" data-id="element-318">
                  <Home size={24} className="text-[#00d4ff]" data-id="element-319" />
                </div>
                <h3 className="text-xl font-bold mb-4" data-id="element-320">
                  Virtual Property Tours
                </h3>
                <p className="text-gray-300 mb-6" data-id="element-321">
                  Explore properties from the comfort of your home with our
                  immersive VR tours. Experience every detail as if you were
                  there in person.
                </p>
                <a href="#contact" className="inline-flex items-center text-[#00d4ff] font-medium hover:text-white group" data-id="element-322">
                  Learn more{' '}
                  <ArrowRight size={16} className="ml-2 transition-transform duration-300 group-hover:translate-x-1" data-id="element-323" />
                </a>
              </div>
              <div className="bg-glass rounded-xl p-8 card-hover neon-border reveal" data-id="element-324">
                <div className="w-12 h-12 bg-[rgba(255,0,128,0.2)] rounded-lg flex items-center justify-center mb-6" data-id="element-325">
                  <Users size={24} className="text-[#ff0080]" data-id="element-326" />
                </div>
                <h3 className="text-xl font-bold mb-4" data-id="element-327">Remote Closings</h3>
                <p className="text-gray-300 mb-6" data-id="element-328">
                  Complete your property purchase remotely with our secure
                  digital closing process, saving time and eliminating
                  geographical barriers.
                </p>
                <a href="#contact" className="inline-flex items-center text-[#ff0080] font-medium hover:text-white group" data-id="element-329">
                  Learn more{' '}
                  <ArrowRight size={16} className="ml-2 transition-transform duration-300 group-hover:translate-x-1" data-id="element-330" />
                </a>
              </div>
              <div className="bg-glass rounded-xl p-8 card-hover neon-border reveal" data-id="element-331">
                <div className="w-12 h-12 bg-[rgba(121,40,202,0.2)] rounded-lg flex items-center justify-center mb-6" data-id="element-332">
                  <Building size={24} className="text-[#7928ca]" data-id="element-333" />
                </div>
                <h3 className="text-xl font-bold mb-4" data-id="element-334">
                  Premium Listings Access
                </h3>
                <p className="text-gray-300 mb-6" data-id="element-335">
                  Gain exclusive access to our curated selection of premium
                  properties before they hit the market through our subscription
                  service.
                </p>
                <a href="#contact" className="inline-flex items-center text-[#7928ca] font-medium hover:text-white group" data-id="element-336">
                  Learn more{' '}
                  <ArrowRight size={16} className="ml-2 transition-transform duration-300 group-hover:translate-x-1" data-id="element-337" />
                </a>
              </div>
            </>}
          {activeTab === 'developers' && <>
              <div className="bg-glass rounded-xl p-8 card-hover neon-border reveal" data-id="element-338">
                <div className="w-12 h-12 bg-[rgba(0,212,255,0.2)] rounded-lg flex items-center justify-center mb-6" data-id="element-339">
                  <Building size={24} className="text-[#00d4ff]" data-id="element-340" />
                </div>
                <h3 className="text-xl font-bold mb-4" data-id="element-341">Digital Showrooms</h3>
                <p className="text-gray-300 mb-6" data-id="element-342">
                  Create interactive 3D showrooms for your developments,
                  allowing clients to explore layouts and toggle different
                  finishes and features.
                </p>
                <a href="#contact" className="inline-flex items-center text-[#00d4ff] font-medium hover:text-white group" data-id="element-343">
                  Learn more{' '}
                  <ArrowRight size={16} className="ml-2 transition-transform duration-300 group-hover:translate-x-1" data-id="element-344" />
                </a>
              </div>
              <div className="bg-glass rounded-xl p-8 card-hover neon-border reveal" data-id="element-345">
                <div className="w-12 h-12 bg-[rgba(255,0,128,0.2)] rounded-lg flex items-center justify-center mb-6" data-id="element-346">
                  <Users size={24} className="text-[#ff0080]" data-id="element-347" />
                </div>
                <h3 className="text-xl font-bold mb-4" data-id="element-348">VR Sales Suites</h3>
                <p className="text-gray-300 mb-6" data-id="element-349">
                  Impress investors and clients with immersive VR presentations
                  that showcase your properties in stunning detail and realism.
                </p>
                <a href="#contact" className="inline-flex items-center text-[#ff0080] font-medium hover:text-white group" data-id="element-350">
                  Learn more{' '}
                  <ArrowRight size={16} className="ml-2 transition-transform duration-300 group-hover:translate-x-1" data-id="element-351" />
                </a>
              </div>
              <div className="bg-glass rounded-xl p-8 card-hover neon-border reveal" data-id="element-352">
                <div className="w-12 h-12 bg-[rgba(121,40,202,0.2)] rounded-lg flex items-center justify-center mb-6" data-id="element-353">
                  <Home size={24} className="text-[#7928ca]" data-id="element-354" />
                </div>
                <h3 className="text-xl font-bold mb-4" data-id="element-355">
                  Cinematic Walkthroughs
                </h3>
                <p className="text-gray-300 mb-6" data-id="element-356">
                  Showcase your properties with professionally created cinematic
                  virtual walkthroughs that highlight the best features and
                  spaces.
                </p>
                <a href="#contact" className="inline-flex items-center text-[#7928ca] font-medium hover:text-white group" data-id="element-357">
                  Learn more{' '}
                  <ArrowRight size={16} className="ml-2 transition-transform duration-300 group-hover:translate-x-1" data-id="element-358" />
                </a>
              </div>
            </>}
          {activeTab === 'additional' && <>
              <div className="bg-glass rounded-xl p-8 card-hover neon-border reveal" data-id="element-359">
                <div className="w-12 h-12 bg-[rgba(0,212,255,0.2)] rounded-lg flex items-center justify-center mb-6" data-id="element-360">
                  <Users size={24} className="text-[#00d4ff]" data-id="element-361" />
                </div>
                <h3 className="text-xl font-bold mb-4" data-id="element-362">
                  Relocation Assistance
                </h3>
                <p className="text-gray-300 mb-6" data-id="element-363">
                  Comprehensive support for individuals and families relocating
                  to Nigeria, including property finding, virtual tours, and
                  settling-in services.
                </p>
                <a href="#contact" className="inline-flex items-center text-[#00d4ff] font-medium hover:text-white group" data-id="element-364">
                  Learn more{' '}
                  <ArrowRight size={16} className="ml-2 transition-transform duration-300 group-hover:translate-x-1" data-id="element-365" />
                </a>
              </div>
              <div className="bg-glass rounded-xl p-8 card-hover neon-border reveal" data-id="element-366">
                <div className="w-12 h-12 bg-[rgba(255,0,128,0.2)] rounded-lg flex items-center justify-center mb-6" data-id="element-367">
                  <Building size={24} className="text-[#ff0080]" data-id="element-368" />
                </div>
                <h3 className="text-xl font-bold mb-4" data-id="element-369">Property Management</h3>
                <p className="text-gray-300 mb-6" data-id="element-370">
                  Digital-first property management solutions with VR
                  inspections, maintenance tracking, and tenant communication
                  tools.
                </p>
                <a href="#contact" className="inline-flex items-center text-[#ff0080] font-medium hover:text-white group" data-id="element-371">
                  Learn more{' '}
                  <ArrowRight size={16} className="ml-2 transition-transform duration-300 group-hover:translate-x-1" data-id="element-372" />
                </a>
              </div>
              <div className="bg-glass rounded-xl p-8 card-hover neon-border reveal" data-id="element-373">
                <div className="w-12 h-12 bg-[rgba(121,40,202,0.2)] rounded-lg flex items-center justify-center mb-6" data-id="element-374">
                  <Home size={24} className="text-[#7928ca]" data-id="element-375" />
                </div>
                <h3 className="text-xl font-bold mb-4" data-id="element-376">Investment Advisory</h3>
                <p className="text-gray-300 mb-6" data-id="element-377">
                  Expert guidance on real estate investments in Nigeria, with
                  detailed virtual property assessments and market analysis.
                </p>
                <a href="#contact" className="inline-flex items-center text-[#7928ca] font-medium hover:text-white group" data-id="element-378">
                  Learn more{' '}
                  <ArrowRight size={16} className="ml-2 transition-transform duration-300 group-hover:translate-x-1" data-id="element-379" />
                </a>
              </div>
            </>}
        </div>
      </div>
    </section>;
};